import React from "react";
import { MapContainer, TileLayer, Circle, CircleMarker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const zoomForRadius = (mi) => (mi <= 5 ? 12 : mi <= 10 ? 11 : mi <= 15 ? 11 : mi <= 25 ? 10 : 9);

export default function HotelMap({ center, radiusMiles = 15, hotels = [] }) {
  if (!center?.lat || !center?.lng) return null;
  const pos = [center.lat, center.lng];
  const pts = hotels.filter((h) => h.lat && h.lng);
  return (
    <div className="h-[520px] border border-[#111827]" data-testid="discover-map">
      <MapContainer center={pos} zoom={zoomForRadius(radiusMiles)} scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Circle center={pos} radius={radiusMiles * 1609.34}
          pathOptions={{ color: "#002FA7", fillColor: "#002FA7", fillOpacity: 0.05, weight: 1 }} />
        <CircleMarker center={pos} radius={8}
          pathOptions={{ color: "#111827", fillColor: "#111827", fillOpacity: 1, weight: 2 }}>
          <Popup>Search center · {center.location}</Popup>
        </CircleMarker>
        {pts.map((h, i) => (
          <CircleMarker key={(h.hotel_id || h.name) + i} center={[h.lat, h.lng]} radius={6}
            pathOptions={{
              color: h.on_platform ? "#047857" : "#D97706",
              fillColor: h.on_platform ? "#047857" : "#D97706",
              fillOpacity: 0.9, weight: 1,
            }}>
            <Popup>
              <div style={{ minWidth: 150 }}>
                <strong>{h.name}</strong><br />
                {h.on_platform ? "On RateBridge" : "New"} · {h.type || "hotel"}
                {h.stars ? ` · ${h.stars}★` : ""}<br />
                {typeof h.distance_miles === "number" ? `${h.distance_miles} mi away` : ""}
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
